import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Member from './pages/Member';

export default function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+\d{1,3}[\s-]?\d{2,}([\s-]?\d+)*$/;

    if (!emailRegex.test(formData.email)) {
      alert('Veuillez entrer une adresse e-mail valide.');
      return;
    }
    if (!phoneRegex.test(formData.phone)) {
      alert('Veuillez entrer un numéro de téléphone valide avec le préfixe +.');
      return;
    }

    try {
      const res = await fetch('/api/member-register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          website: ''
        })
      });

      const body = await res.json().catch(() => ({}));
      if (res.ok && body.status === 'registered') {
        alert(body.message || 'Merci ! Votre inscription a bien été envoyée.');
        setFormData({ firstName: '', lastName: '', email: '', phone: '' });
      } else if (res.ok && body.status === 'already_registered') {
        alert(body.message || 'Vous êtes déjà membre. Un e-mail vous a été envoyé.');
      } else {
        if (body.details) {
          console.error('API details:', body.details);
        }
        alert(body.error || 'Une erreur est survenue lors de l’envoi du formulaire.');
      }
    } catch (err) {
      console.error('Erreur de soumission :', err);
      alert('Erreur réseau. Vérifiez votre connexion et réessayez.');
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 flex flex-col">
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      <main className="pt-20 flex-1">
        {activeTab === 'home' ? (
          <Home setActiveTab={setActiveTab} />
        ) : (
          <Member
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
          />
        )}
      </main>
      <Footer />
    </div>
  );
}